export const roundLocation = (num: number) => {
  return Number.parseInt(num.toPrecision(3));
};
